import { Component, Output, Input, EventEmitter } from '@angular/core';
import { GaService } from '../common/services/ga.service';
import { UrlEnvService } from "../common/services/url-env.service";

@Component({
  selector: 'aha-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  @Input() isMobileMenuOpen;
  @Input() smallSideBarOpen;
  @Output() toggleMobileMenu: EventEmitter<boolean> = new EventEmitter();
  @Output() toggleSmallSideBar: EventEmitter<boolean> = new EventEmitter();
  statsUrl: string;
  dataQueryUrl: string;
  dataQueryUrlSideNav: string;

  constructor(private gaService: GaService, private urlEnvService: UrlEnvService) {
    this.statsUrl = this.urlEnvService.getStatsUrl();
    this.dataQueryUrl = this.urlEnvService.getDataQueryUrl();
    this.dataQueryUrlSideNav = this.urlEnvService.getDataQueryUrlSideNav();
  }

  hideSideNavBar() {
    this.toggleMobileMenu.emit(!this.isMobileMenuOpen);
  }

  toggleSideBarSize() {
    this.toggleSmallSideBar.emit(!this.smallSideBarOpen);
  }

  addToGA() {
    //google analytics
    this.gaService.addSideBarClick();
  }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts